import { pipe, merge, mergeWith, values, map, reduce, indexBy, prop } from 'ramda';

export const mergeAndSortAvailability = pipe(
  map(indexBy(prop('date'))),
  reduce(mergeWith(merge), {}),
  values
);
